export default __webpack_public_path__ + "static/media/3.6a314056.png";